/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1Pipeline } from './V2beta1Pipeline';
import {
  V2beta1PipelineFromJSON,
  V2beta1PipelineFromJSONTyped,
  V2beta1PipelineToJSON,
  V2beta1PipelineToJSONTyped,
} from './V2beta1Pipeline';

/**
 *
 * @export
 * @interface V2beta1ListPipelinesResponse
 */
export interface V2beta1ListPipelinesResponse {
  /**
   * Returned pipelines.
   * @type {Array<V2beta1Pipeline>}
   * @memberof V2beta1ListPipelinesResponse
   */
  pipelines?: Array<V2beta1Pipeline>;
  /**
   * The total number of pipelines for the given query.
   * @type {number}
   * @memberof V2beta1ListPipelinesResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of pipelines.
   * This token can be used on the next ListPipelinesRequest.
   * @type {string}
   * @memberof V2beta1ListPipelinesResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the V2beta1ListPipelinesResponse interface.
 */
export function instanceOfV2beta1ListPipelinesResponse(
  value: object,
): value is V2beta1ListPipelinesResponse {
  return true;
}

export function V2beta1ListPipelinesResponseFromJSON(json: any): V2beta1ListPipelinesResponse {
  return V2beta1ListPipelinesResponseFromJSONTyped(json, false);
}

export function V2beta1ListPipelinesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ListPipelinesResponse {
  if (json == null) {
    return json;
  }
  return {
    pipelines:
      json['pipelines'] == null
        ? undefined
        : (json['pipelines'] as Array<any>).map(V2beta1PipelineFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function V2beta1ListPipelinesResponseToJSON(json: any): V2beta1ListPipelinesResponse {
  return V2beta1ListPipelinesResponseToJSONTyped(json, false);
}

export function V2beta1ListPipelinesResponseToJSONTyped(
  value?: V2beta1ListPipelinesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipelines:
      value['pipelines'] == null
        ? undefined
        : (value['pipelines'] as Array<any>).map(V2beta1PipelineToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
